/* eslint-disable complexity */
import { getCurrLayer } from "../utils/layerData";
import { extractSoilSsurgoZones } from '../utils/layerData/mosaic/soilSsurgo';
import {
  BASE_LAYERS,
  IMPORTED_SHAPEFILE,
  SOIL_MAP,
} from '../constants/mapLayerIds';
import {
  RECEIVE_SELECTOR_VALS,
  RECEIVE_PRODUCT_ASSETS,
  RECEIVE_SOIL_SSURGO_ZONES,
  REQUEST_APP_INITIALIZER,
  SET_ACTIVE_SELECTOR_VALS,
  SET_ACTIVE_SUB_LAYER,
  SET_FHA_TIMELAPSE_PLAYING,
  SOIL_SSURGO_ZONES_FAILURE,
  RECEIVE_IMPORTED_SHAPEFILE_DATA,
  IMPORTED_SHAPEFILE_DATA_FAILURE,
} from '../constants/actionTypes';

import { extractImportedShapefileProperties } from '../utils/layerData/mosaic/importedShapefile';

import {
  agVizLayersReducer,
  initialState,
  untypedUpdateLayerValues
} from './agVizLayersReducer';

export { initialState } from './agVizLayersReducer';

// TODO - Remove SonarQube disablement after BTR-931 is done.
function layersReducer(state = initialState, action) {
  // NOSONAR
  switch (action.type) {
    case REQUEST_APP_INITIALIZER: {
      return {
        ...state,
        activeMapLayers: action.mapLayerIds.length
          ? action.mapLayerIds.map((layer) => ({ id: layer }))
          : initialState.activeMapLayers,
        isSplitViewEnabled: action.mapLayerIds.length > 1,
      };
    }
    case RECEIVE_SELECTOR_VALS: {
      const { activeVals, layers } = action;
      return {
        ...state,
        activeMapLayers: activeVals.activeMapLayers,
        list: layers,
        isSplitViewEnabled: activeVals.activeMapLayers.length > 1,
      };
    }
    case SET_ACTIVE_SELECTOR_VALS: {
      return {
        ...state,
        activeMapLayers: action.activeMapLayers,
        isSplitViewEnabled: action.activeMapLayers.length > 1,
      };
    }

    case RECEIVE_PRODUCT_ASSETS:
      return action.payload.featuresByFields[0].features.includes(SOIL_MAP)
        ? state
        : {
            ...state,
            disabledMapLayers: [
              ...state.disabledMapLayers,
              BASE_LAYERS.SOIL_SSURGO,
            ],
          };
    case SET_ACTIVE_SUB_LAYER: {
      const { activeSubLayer, layer, season, view } = action;
      const currLayer = getCurrLayer(state.list, layer, season);
      const current = currLayer.activeSubLayerIds || currLayer.current;
      const newactiveSubLayerIds = {
        [currLayer.activeSubLayerIds ? 'activeSubLayerIds' : 'current']:
          current.map((subLayer, index) =>
            index === view ? activeSubLayer : subLayer
          ),
      };
      return untypedUpdateLayerValues(state, layer, newactiveSubLayerIds, season);
    }
    case RECEIVE_SOIL_SSURGO_ZONES: {
      const zones = { zones: extractSoilSsurgoZones(action.zones) };
      return untypedUpdateLayerValues(state, BASE_LAYERS.SOIL_SSURGO, zones);
    }
    case SOIL_SSURGO_ZONES_FAILURE: {
      const zones = { zones: [] };
      return untypedUpdateLayerValues(state, BASE_LAYERS.SOIL_SSURGO, zones);
    }
    case RECEIVE_IMPORTED_SHAPEFILE_DATA: {
      const properties = {
        properties: extractImportedShapefileProperties(
          action.shapefile.features
        ),
      };
      return untypedUpdateLayerValues(state, IMPORTED_SHAPEFILE, properties);
    }
    case IMPORTED_SHAPEFILE_DATA_FAILURE: {
      const properties = { properties: [] };
      return untypedUpdateLayerValues(state, IMPORTED_SHAPEFILE, properties);
    }
    case SET_FHA_TIMELAPSE_PLAYING: {
      return {
        ...state,
        isFhaTimelapsePlaying: !!action.isPlaying,
      };
    }
    default: {
      return agVizLayersReducer(state, action);
    }
  }
}

export default layersReducer;
